import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const hasProcessed = useRef(false);
  const nav = useNavigate();
  const { loginWith } = useAuth();
  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const sid = new URLSearchParams(window.location.hash.slice(1)).get("session_id");
    (async () => {
      try {
        const { data } = await api.post("/auth/session", { session_id: sid });
        loginWith(data);
        window.history.replaceState(null, "", window.location.pathname);
        nav("/dashboard", { replace: true, state: { user: data.user } });
      } catch (e) {
        toast.error(errMsg(e));
        window.history.replaceState(null, "", "/login");
        nav("/login", { replace: true, state: { googleError: errMsg(e) } });
      }
    })();
  }, [nav, loginWith]);
  return <div className="flex min-h-screen items-center justify-center text-sm text-muted-foreground">Memverifikasi sesi Google...</div>;
}
